enum type {
  SET_TOKEN = 'SET_TOKEN',
  SET_LOADING_TOKEN = 'SET_LOADING_TOKEN',
  SET_AUTH_TYPE = 'SET_AUTH_TYPE',
  SET_PAGE_TITLE = 'SET_PAGE_TITLE',
}

export default type;